import { z } from 'zod';
import { ErrorResponseSchema } from '../../common/base';

/**
 * Request schema for base64 photo upload
 * POST /api/user/upload-photo-base64
 */
export const UploadPhotoBase64RequestSchema = z.object({
  /** Base64-encoded image data */
  base64Image: z.string().min(1, 'Image data is required'),
});

export type UploadPhotoBase64Request = z.infer<typeof UploadPhotoBase64RequestSchema>;

/**
 * Success response schema for upload-photo-base64 endpoint
 */
const UploadPhotoBase64SuccessSchema = z.object({
  success: z.literal(true),
  /** User ID */
  userId: z.number(),
});

export type UploadPhotoBase64Success = z.infer<typeof UploadPhotoBase64SuccessSchema>;

/**
 * Combined response schema for upload-photo-base64 endpoint
 * Discriminated union based on success field
 *
 * @example
 * ```typescript
 * const response = UploadPhotoBase64ResponseSchema.parse(data);
 * if (response.success) {
 *   console.log('Photo uploaded for user:', response.userId);
 * }
 * ```
 */
export const UploadPhotoBase64ResponseSchema = z.discriminatedUnion('success', [
  UploadPhotoBase64SuccessSchema,
  ErrorResponseSchema,
]);

export type UploadPhotoBase64Response = z.infer<typeof UploadPhotoBase64ResponseSchema>;
